import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0.966797C8.94117 0.966814 9.84424 1.34037 10.5098 2.00586C10.7048 2.20101 10.7046 2.51763 10.5098 2.71289C10.3145 2.90809 9.99799 2.90804 9.80273 2.71289C9.32475 2.23493 8.67596 1.96681 8 1.9668C7.32401 1.96681 6.67526 2.2349 6.19727 2.71289C5.71929 3.19088 5.45119 3.83965 5.45117 4.51562V6.19336H12.791C13.0671 6.19343 13.291 6.41726 13.291 6.69336V14.5332C13.291 14.8093 13.0671 15.0331 12.791 15.0332H3.20898C2.93285 15.0332 2.709 14.8093 2.70898 14.5332V6.69336C2.70898 6.41722 2.93284 6.19336 3.20898 6.19336H4.45117V4.51562C4.45119 3.57444 4.82472 2.67139 5.49023 2.00586C6.15577 1.34033 7.0588 0.966813 8 0.966797ZM3.70898 14.0332H12.291V7.19336H3.70898V14.0332ZM8 9.24219C8.2761 9.24222 8.49998 9.46608 8.5 9.74219V11.4844C8.5 11.7605 8.27611 11.9843 8 11.9844C7.72386 11.9844 7.5 11.7605 7.5 11.4844V9.74219C7.50002 9.46606 7.72387 9.24219 8 9.24219Z",
		fill: "currentColor"
	})
});
export default SvgOpenLock;
